import { inRange } from 'lodash-es';

import type { AnyNumberScale } from '../../../types/scales.js';

export function getNextPanDomain<T extends number>(
  initialDomain: [T, T],
  currentScale: AnyNumberScale,
  delta: number,
  isWheel: boolean,
  infiniteZoom?: boolean,
): [T, T] {
  const [rangeMin, rangeMax] = currentScale.range();
  const [initialMin, initialMax] = initialDomain;
  const [currentMin, currentMax] = currentScale.domain();
  const deltaSign = isWheel ? -1 : 1;
  const newMin = currentScale.invert(rangeMin - delta * deltaSign).valueOf();
  const newMax = currentScale.invert(rangeMax - delta * deltaSign).valueOf();

  if (infiniteZoom) {
    return [newMin, newMax] as [T, T];
  }

  if (!inRange(newMin, initialMin, initialMax)) {
    const diffToInitial = +currentMin - +initialMin;
    return [initialMin, +currentMax - diffToInitial] as [T, T];
  }

  if (!inRange(newMax, initialMin, initialMax)) {
    const diffToInitial = +initialMax - +currentMax;
    return [+currentMin + diffToInitial, initialMax] as [T, T];
  }

  // Need a cast here, because newMin or newMax will not deviate types
  // between each other, but typescript cannot differentiate here.
  return [newMin, newMax] as [T, T];
}
